import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import { injectIntl } from 'react-intl';
import RemoveButton from '../Buttons/RemoveButton';

class TypedConfirmationDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  handleChange = name => (event) => {
    this.setState({
      [name]: event.target.value,
    });
  };

  handleRemove() {
    this.props.onConfirmed();
  }

  handleClose = () => {
    this.setState({ title: '' });
    this.props.onRequestClose();
  };

  render() {
    const { open, matchText, content, intl, confirmationBtnText } = this.props;
    return (
      <Dialog
        id="form-dialog-container"
        open={open}
        onClose={e => this.handleClose(e)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle
          id="form-dialog-title"
        >{this.props.title}
        </DialogTitle>
        <DialogContent id="form-dialog-content">
          <DialogContentText>
            {content}
          </DialogContentText>
          <TextField
            value={this.state.title}
            margin="dense"
            id="with-placeholder"
            label={intl.formatMessage({ id: 'advancedSettings.confirmationText' })}
            placeholder="Confirmation Text"
            fullWidth
            onChange={this.handleChange('title')}
          />
        </DialogContent>
        <DialogActions id="form-dialog-actions">
          <Button
            id="btn-cancel"
            onClick={this.handleClose}
            color="primary"
            variant="outlined"
          >
            {intl.formatMessage({ id: 'cancel' })}
          </Button>
          <RemoveButton
            id="btn-submit"
            onClick={() => this.handleRemove()}
            disabled={this.state.title !== matchText}
          >
            {
              confirmationBtnText ? confirmationBtnText : `${intl.formatMessage({ id: 'remove' })}`
            }
          </RemoveButton>
        </DialogActions>
      </Dialog>
    );
  }
}

TypedConfirmationDialog.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.instanceOf(Object).isRequired,
  open: PropTypes.bool.isRequired,
  onConfirmed: PropTypes.instanceOf(Function).isRequired,
  onRequestClose: PropTypes.instanceOf(Function).isRequired,
  matchText: PropTypes.string.isRequired,
};

export default injectIntl(TypedConfirmationDialog);
